import { useMemo } from 'react'

import { useCarWash } from '@/hooks/use-carwash'

export type NavCount = {
    count: number
    label: string
}

/* Small counts shown on the navigation: vehicles waiting and unpaid bills. */
export const useNavCounts = (): Record<string, NavCount> => {
    const { state } = useCarWash()

    return useMemo(() => {
        if (!state) return {}

        return {
            '/vehicles': {
                count: state.jobs.filter(job => job.status === 'waiting').length,
                label: 'waiting'
            },
            '/billing': {
                count: state.invoices.filter(invoice => invoice.status === 'pending').length,
                label: 'unpaid'
            }
        }
    }, [state])
}
